/* eslint-disable react-refresh/only-export-components */
import { ColumnHelper } from "@tanstack/react-table";
import isEmpty from "lodash/isEmpty";
import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { EmptyCell } from "PFApp/activities/manage_roles/parts/empty_cell";
import { ProfileInfo } from "PFApp/activities/manage_roles/parts/profile_info";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ManageRolesMultiForm, WMProfile } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Stack } from "PFComponents/containers";
import { useWatch } from "react-hook-form";

import css from "./cell.module.scss";

const BOOKED_WM_COLUMN_WIDTH = 150;

type BookedWmCellProps = {
  rolesFormKey: RolesFormKey;
  rowIndex: number;
};

const BookedWmCell = ({ rolesFormKey, rowIndex }: BookedWmCellProps) => {
  const name = `${rolesFormKey}.${rowIndex}.booked_wm` as const;
  const profiles = useWatch<ManageRolesMultiForm>({ name }) as WMProfile[] | undefined;

  if (isEmpty(profiles)) {
    return <EmptyCell />;
  }

  return (
    <Stack className={css.cell}>
      {(profiles ?? []).map((profile) => (
        <ProfileInfo key={profile.id} profile={profile} />
      ))}
    </Stack>
  );
};

export const createBookedWmColumn = (
  columnHelper: ColumnHelper<ManageRolesTableDataItem>,
  rolesFormKey: RolesFormKey,
  headerLabel: string
) =>
  columnHelper.accessor((row) => row, {
    id: "booked_wm",
    header: () => <span>{headerLabel}</span>,
    cell: (info) => <BookedWmCell rolesFormKey={rolesFormKey} rowIndex={info.row.index} />,
    size: BOOKED_WM_COLUMN_WIDTH,
    meta: {
      getIsCopyPasteBlocked: () => true
    }
  });
